import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { VideoShowcase } from './components/VideoShowcase';
import { Demo } from './components/Demo';
import { ThreatModel } from './components/ThreatModel';
import { Abstract, Dataset, Evaluation } from './components/Sections';
import { Footer } from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Navigation />
      <Hero />
      <VideoShowcase />
      <Demo />
      <Abstract />
      <ThreatModel />
      <Dataset />
      <Evaluation />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
